import { Component, input, InputSignal } from '@angular/core';
import { RouterLink } from '@angular/router';

import { RxButtonModule } from '../button/button.module';
import { NgClass, NgForOf, NgIf, SlicePipe } from '@angular/common';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { IconSvgComponent } from '../icon/icon.component';

@Component({
  selector: 'rx-card-box',
  standalone: true,
  templateUrl: './card-box.component.html',
  styleUrls: ['./card-box.component.scss'],
  imports: [RouterLink, RxButtonModule, SlicePipe, NgClass, IconSvgComponent, LoadingSpinnerComponent, NgIf, NgForOf],
})
export class CardBoxComponent {
  title: InputSignal<string> = input<string>();
  icon: InputSignal<string> = input<string>();
  link: InputSignal<string> = input<string>();
  showLink: InputSignal<boolean> = input<boolean>();
  linkText: InputSignal<string> = input<string>();
  isLoading: InputSignal<boolean> = input<boolean>();
  noDataMessage: InputSignal<string> = input<string>();
  hasData: InputSignal<boolean> = input<boolean>();
  testIdPrefix: InputSignal<string> = input<string>('');
}
